export default __webpack_public_path__ + "static/media/puzzle4.e47d9c71.svg";